import { isInStoreOnly } from "@/utils/variant/isInStoreOnly";
import { isMadeToMeasure } from "@/utils/product/isMadeToMeasure";
import { isPerMetre } from "@/utils/product/isPerMetre";
import { getDefaultTermsAndConditions } from "@/utils/product/getDefaultTermsAndConditions";
import { StandardProps } from "../componentMap";
import { UserAcknowledgementUI } from "./UserAcknowledgementUI";
import { useVariant } from "@/hooks/useVariant/useVariant";

export function UserAcknowledgement({
  product,
}: Pick<StandardProps, "product">) {
  const { termsAndConditions } = product;
  const { variant } = useVariant(product);
  const isInStoreOnlyVariant = isInStoreOnly(variant);
  const isM2MProduct = isMadeToMeasure(product);
  const isPerMetreProduct = isPerMetre(product);

  if (
    isInStoreOnlyVariant ||
    (!termsAndConditions?.customerConfirmationRequired &&
      !(isM2MProduct || isPerMetreProduct))
  ) {
    return null;
  }

  return (
    <UserAcknowledgementUI
      terms={
        termsAndConditions?.detail || getDefaultTermsAndConditions(isM2MProduct)
      }
      includeTsAndCsLink={isM2MProduct}
    />
  );
}
